import { useMenuFooterRegistration } from '#pplx/frontend/aether/components/internal/menu/useMenuFooterRegistry.js';
/**
 * Renders its children outside the scrollable area, pinned to the bottom of the menu.
 * Must be used within a `Menu` or `Menu.Submenu`.
 *
 * Content is hoisted via the MenuProvider's footer registry so it renders
 * below the ScrollArea while being authored inline with other menu children.
 */
export function MenuFooter({ children }) {
    useMenuFooterRegistration(children);
    return null;
}
//# sourceMappingURL=MenuFooter.js.map